import type { IStore } from '../../../stores/Store';
import fetchProspectBucketByAdcentreProspectId from '../../../graphql/fetchProspectBucketByAdcentreProspectId';
import updateBucketAndRefreshPage from './updateBucketAndRefreshPage';
import { getAdvertiserIds, isValidId } from 'src/utils/advertiserIds';
import { navigateToSignInPageWithReturnUrl } from './utils';

const changeBucketForSelectedJobApplication = async (
  store: IStore,
  positionId: number,
  selectedProspectId: string,
) => {
  const { seekAdvertiserId } = getAdvertiserIds();

  if (!isValidId(seekAdvertiserId)) {
    return navigateToSignInPageWithReturnUrl();
  }
  const bucket = await fetchProspectBucketByAdcentreProspectId(
    positionId,
    seekAdvertiserId,
    selectedProspectId,
  );

  if (bucket && bucket !== store.jobApplicationStore.bucket) {
    updateBucketAndRefreshPage(bucket);
  }
};

export default changeBucketForSelectedJobApplication;
